// eslint-disable-next-line no-unused-vars
import { RuleWithModels, ZoneWithRules } from '@/models/SettingsModels'

const defaultTagIcon = { value: 'tag_default_icon', color: '#FFDC00', fill: 'black', position: 12 }

export function zoneIcons (zone: ZoneWithRules) {
  const [rule] = zone.associatedRules
  const icons = { tagIcon: { ...defaultTagIcon }, letterIcon: null }

  if (!rule) {
    return icons
  }

  return ruleV2Icons(rule)
}

export function ruleV2Icons (rule: RuleWithModels) {
  const icons = { tagIcon: { ...defaultTagIcon }, letterIcon: null }
  const { pilot, tag } = rule

  if (pilot) {
    icons.letterIcon = { value: pilot.initial, color: pilot.color, fill: 'white' }
  }

  if (tag) {
    icons.tagIcon = { value: tag.iconName, color: tag.color, fill: 'white', position: 12 }
  }

  return icons
}
